import * as Actions from '../actions'

const initialState = {
  data: [],
  count: 0,
  lists: [],
  searchText: '',
  page: 0,
  limit: 10
}

const productsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PRODUCTS:
      {
        return {
          ...state,
          data: action.payload,
          page: action.page,
          limit: action.limit
        }
      }
    case Actions.LIST_PRICES:
      {
        return {
          ...state,
          lists: action.payload
        }
      }
    case Actions.COUNT_PRODUCTS:
      {
        return {
          ...state,
          count: action.count
        }
      }
    case Actions.SEARCH_PRODUCTS:
      {
        return {
          ...state,
          searchText: action.query,
          data: action.payload
        }
      }
    case Actions.SET_PRODUCTS_SEARCH_TEXT:
      {
        return {
          ...state,
          searchText: action.searchText
        }
      }
    default:
      {
        return state
      }
  }
}

export default productsReducer
